module.exports = __webpack_public_path__ + "static/media/icon_usuario.5dad0022.svg";